import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

// Todo's : accessible à tout utilisateur connecté (ROLE_USER). Le cloisonnement
// (créateur / cible) est appliqué côté serveur.
export const TodosRouter = React.memo(() => (
  <SubRouter loggedIn>
    <Route index element={<Index />} />
  </SubRouter>
))
